export const shortBeepDuration = 250;
export const longBeepDuration = 400;
export const beepVolume = 1;
export const defaultScanner = "2D Barcode Imager";
export const verbose = 0;
